import React from 'react';
import PropTypes from 'prop-types';

const RequestSOWModal = ({onConfirm, children}) => {
    return (
        <div className="request-sow-container">
            <p className="request-sow-header">
                {`Please confirm that you would like to request a SOW for this project.\nEstimated timing and pricing is below.`}
            </p>
            <p className="request-sow-note alert-secondary px-4 py-2">
                <i className="fas fa-info-circle mr-3"/> Note: you can cancel the SOW later if you change your mind
            </p>

            {children}

            <div className="request-sow-actions">
                <button className="btn btn-outline-dark" onClick={() => TB.event("Modal@hide")}>
                    Cancel
                </button>
                <button className="btn btn-primary" onClick={async() => {
                    await TB.event("Modal@hide");
                    onConfirm()
                }}>
                    Ok
                </button>
            </div>
        </div>
    );
};

RequestSOWModal.propTypes = {
    project: PropTypes.object,
    onConfirm: PropTypes.func
};

export default RequestSOWModal;